import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";

// App-wide look for helper tooltips: dark card, rounded, with an arrow, a bold first
// line, an optional second line (counts / detail) and a small hint line. Replaces the
// browser's plain `title` tooltip, which cannot be styled and appears after a long delay.
const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#0f172a",
    color: "#fff",
    borderRadius: 10,
    padding: "7px 11px",
    boxShadow: "0 10px 28px -8px rgba(15,23,42,0.5)",
    maxWidth: 260,
    fontSize: 12,
    lineHeight: 1.35,
  },
  arrow: { color: "#0f172a" },
})(Tooltip);

const Tip = ({ title, subtitle, hint, children, placement = "top", ...rest }) => {
  if (!title) return children;
  return (
    <StyledTooltip
      arrow
      placement={placement}
      enterDelay={150}
      enterNextDelay={80}
      leaveDelay={0}
      title={
        <span style={{ display: "block" }}>
          <span style={{ display: "block", fontWeight: 800 }}>{title}</span>
          {subtitle && <span style={{ display: "block", color: "#cbd5e1", marginTop: 1 }}>{subtitle}</span>}
          {hint && <span style={{ display: "block", color: "#fdba74", marginTop: 3, fontSize: 11, fontWeight: 700 }}>{hint}</span>}
        </span>
      }
      {...rest}
    >
      {children}
    </StyledTooltip>
  );
};

export default Tip;
